import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Box, Text, Image} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import {Alert, Screen, LogoHorizontal} from '../../../components'
import oAuthLoginRedirect from '../../../../utils/oAuthLoginRedirect'
import useAccountingProviderLogo from '../../../hooks/useAccountingProviderLogo'

const AccountingProviderReconnect = ({
  accountingProvider,
  companyFileMissing,
}) => {
  const {t} = useTranslation('onboarding')
  const accountingImage = useAccountingProviderLogo({
    accountingProviderName: accountingProvider,
  })

  return (
    <Screen>
      <Flex align="center" justify="center">
        <Box w="50%">
          <LogoHorizontal width={380} />
          {companyFileMissing && (
            <Alert
              status="error"
              message={t(
                'onboarding:AccountingProviderReconnect.companyFileMissing',
              )}
              mb={4}
            />
          )}
          <Text fontSize="md" mb="sm">
            To continue using Marmalade, please reconnect your{' '}
            {accountingProvider} account.
          </Text>

          <Box
            borderColor="neutral.10"
            borderWidth="1px"
            display="inline-flex"
            alignItems="center"
            w="100%"
            h="4.6rem"
            px={4}
            py={2}
            mb={3}
            opacity={1}
            borderRadius="lg"
            as="button"
            onClick={() => {
              oAuthLoginRedirect(accountingProvider)
            }}
          >
            <Image
              src={accountingImage}
              w="40px"
              h="40px"
              alt={accountingProvider}
              mr={3}
            />
            <Text>Connect to {accountingProvider}</Text>
          </Box>
        </Box>
      </Flex>
    </Screen>
  )
}

AccountingProviderReconnect.propTypes = {
  accountingProvider: PropTypes.string.isRequired,
  companyFileMissing: PropTypes.bool,
}

AccountingProviderReconnect.defaultProps = {
  companyFileMissing: false,
}

export default AccountingProviderReconnect
